import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, useAuth } from '../shared';

/**
 * MaintenanceGate: zeigt im Wartungsmodus NUR einen nicht-blockierenden Hinweis-Balken
 * für Admins an. Die Seite bleibt für alle Besucher jederzeit voll erreichbar –
 * der Wartungsmodus blockiert die Seite niemals vollständig.
 */
export default function MaintenanceGate({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState({ maintenance: false, message: '' });

  useEffect(() => {
    axios.get(`${API_URL}/api/maintenance/status`)
      .then(r => setStatus(r.data))
      .catch(() => {});
  }, []);

  const isAdmin = user?.roles?.some(r => ['MainAdmin', 'ExtAdmin', 'CEO'].includes(r));

  return (
    <>
      {status.maintenance && isAdmin && (
        <div data-testid="maintenance-admin-bar" style={{ background: '#ff9800', color: 'white', textAlign: 'center', padding: '8px 16px', fontSize: '13px', fontWeight: 600 }}>
          🛠️ Wartungsmodus aktiv – Benachrichtigungen sind unterdrückt. Die Seite bleibt für alle Besucher voll erreichbar.
        </div>
      )}
      {children}
    </>
  );
}
